import { useAbility } from '@casl/react';

import type { AppAbility } from './ability';
import type { Permission } from './permissions';

/**
 * Ergonomic imperative check. Client-side authorization hides affordances; it does not protect data
 * — the backend remains the enforcement point, and a `<Can>` guard must never be the only thing
 * preventing a privileged call.
 */
export function usePermission() {
  const ability = useAbility<AppAbility>();

  return {
    ability,
    can: (permission: Permission) => ability.can(permission, 'all'),
    cannot: (permission: Permission) => ability.cannot(permission, 'all'),
  };
}
